import {
    GET_GENERIC_CODEBOOK_PENDING,
    GET_GENERIC_CODEBOOK_SUCCESS,
    GET_GENERIC_CODEBOOK_ERROR,
    SET_GENERIC_CODEBOOK_OPTIONS_MAP,
    FILTER_GENERIC_CODEBOOK,
    SHOW_ADD_MODAL_GENERIC_CODEBOOK,
    ADD_GENERIC_CODEBOOK_PENDING,
    ADD_GENERIC_CODEBOOK_SUCCESS,
    ADD_GENERIC_CODEBOOK_ERROR,
    GENERIC_CODEBOOK_DELETED,
    RESET_GENERIC_CODEBOOK_STATE,
    SHOW_EDIT_MODAL_GENERIC_CODEBOOK,
    UPDATE_GENERIC_CODEBOOK_PENDING,
    UPDATE_GENERIC_CODEBOOK_ERROR,
    UPDATE_GENERIC_CODEBOOK_SUCCESS
} from "../actions/types";
import {useSelector} from "react-redux";

const INITIAL_STATE = {
    data: [],
    filteredData: [],
    isLoaded: false,
    optionsMap: [],
    filtersMap: [],
    addModalVisible: false,
    submitPending: false,
    newItem: null,
    editModalVisible: false,
    editItemInitialObject: null,
    columnsDT: []
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_GENERIC_CODEBOOK_PENDING:
            return {
                ...state,
                isLoaded: false
            };
        case GET_GENERIC_CODEBOOK_SUCCESS:
            return {
                ...state,
                isLoaded: true,
                filteredData: action.payload,
                data: action.payload
            };
        case GET_GENERIC_CODEBOOK_ERROR:
            return {
                ...state,
                isLoaded: true,
                data: []
            };
        case SET_GENERIC_CODEBOOK_OPTIONS_MAP:
            return {
                ...state,
                optionsMap: action.payload
            };
        case FILTER_GENERIC_CODEBOOK:
            return {
                ...state,
                filtersMap: action.payload.filtersMap,
                filteredData: action.payload.filteredData
            };
        case SHOW_ADD_MODAL_GENERIC_CODEBOOK:
            return {
                ...state,
                addModalVisible: action.payload
            };
        case SHOW_EDIT_MODAL_GENERIC_CODEBOOK:
            return {
                ...state,
                editModalVisible: action.payload.editModalVisible,
                editItemInitialObject: action.payload.editItemInitialObject
            };
        case ADD_GENERIC_CODEBOOK_PENDING:
            return {
                ...state,
                submitPending: true,
                newItem: null
            };
        case ADD_GENERIC_CODEBOOK_SUCCESS:
            return {
                ...state,
                submitPending: false,
                addModalVisible: false,
                newItem: action.payload,
                filtersMap: [],
                data: state.data.concat(action.payload),
                filteredData: state.filteredData.concat(action.payload)
            };
        case ADD_GENERIC_CODEBOOK_ERROR:
            return {
                ...state,
                submitPending: false,
                newItem: null
            };

        case UPDATE_GENERIC_CODEBOOK_PENDING:
            return {
                ...state,
                submitPending: true
            };
        case UPDATE_GENERIC_CODEBOOK_SUCCESS:
            return {
                ...state,
                submitPending: false,
                editModalVisible: false,
                filtersMap: [],
                data: action.payload,
                filteredData: action.payload
            };
        case UPDATE_GENERIC_CODEBOOK_ERROR:
            return {
                ...state,
                submitPending: false
            };
        case GENERIC_CODEBOOK_DELETED:
            return {
                ...state,
                filtersMap: [],
                data: action.payload,
                filteredData: action.payload
            };
        case RESET_GENERIC_CODEBOOK_STATE:
            return {...INITIAL_STATE};
        default:
            return state;
    }
}

export const genericCodebookSelector = () => state => state.genericCodebook;

export const useGenericCodebookSelector = () => useSelector(genericCodebookSelector());